@if (apError()) {
    <div class="ap-error">
        <ap-illustration
            class="ap-error__icon"
            name="error"
            width="185px"
            height="185px"
            data-testid="error-illustration"
        ></ap-illustration>
        @if (apError().title) {
            <h2 class="tertiary" data-bb="customTitle" data-testid="error-title">{{ apError().title }}</h2>
        }
        @if (!apError().title) {
            <h2 class="tertiary" data-bb="defaultTitle">
                {{ 'aperror.default.title' | apContent }}
            </h2>
        }
        <p class="ap-error__message" [innerHtml]="apError().message" data-testid="error-message"></p>
        @if (apError().showReloadOption) {
            <ap-button [text]="true" (onClick)="reload()" data-testid="error-reload">
                {{ 'aperror.reload' | apContent }}
            </ap-button>
        }
        <ng-content></ng-content>
    </div>
}
